var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SectionRight.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-319fba4a\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SectionRight.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/pages/landing/components/SectionRight.vue
// module id = 39
// module chunks = 0